export default {
    props: {
        messagesDisplay: {
            type: String,
            default: undefined,
            kComposite: 'messages.display'
        }, 
        messagesEmpty: {
            type: String,
            default: undefined,
            kComposite: 'messages.empty'
        }, 
        messagesAllPages: {
            type: String,
            default: undefined,
            kComposite: 'messages.allPages'
        }, 
        messagesPage: {
            type: String,
            default: undefined,
            kComposite: 'messages.page'
        }, 
        messagesOf: {
            type: String,
            default: undefined,
            kComposite: 'messages.of'
        }, 
        messagesItemsPerPage: {
            type: String,
            default: undefined,
            kComposite: 'messages.itemsPerPage'
        }, 
        messagesFirst: {
            type: String,
            default: undefined,
            kComposite: 'messages.first'
        }, 
        messagesPrevious: {
            type: String,
            default: undefined,
            kComposite: 'messages.previous'
        }, 
        messagesNext: {
            type: String,
            default: undefined,
            kComposite: 'messages.next'
        }, 
        messagesLast: {
            type: String,
            default: undefined,
            kComposite: 'messages.last'
        }, 
        messagesRefresh: {
            type: String,
            default: undefined,
            kComposite: 'messages.refresh'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-listview-vue-wrapper/src/KendoPager/Messages.js